import { Box, Divider, Stack, Typography } from '@mui/material';
import { CloudAccountType } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { BulletItem } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/bulletItem';
import { FormTextField } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/formTextField';
import { NumericBulletSection } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/numericBulletSection';
import ButtonWithIcon from '@/components/buttons/buttonWithIcon';
import { PanelWrapper } from '@/components/panels/panelWrapper';

import { useCreateAccount } from '../useCreateAccount';

export const ConnectAwsVaultAccountPanel = ({
  mutate,
  onClose,
}: {
  mutate: () => Promise<void>;
  onClose: () => void;
}) => {
  const [openCloudFormationClicked, setOpenCloudFormationClicked] =
    useState(false);
  const {
    createAccount,
    setAccountId,
    accountId,
    setRoleName,
    roleName,
    isCreationInProgress,
    validateAccount,
  } = useCreateAccount(CloudAccountType.Vault, () => void mutate());

  const onConnectClick = async () => {
    // await dal.cloudAccounts.vault.create({
    //   cloudProvider: Provider.Aws,
    //   // name: 'Vault Account',
    //   // tenantId: initialAccount?.tenantId,
    //   // applicationId: initialAccount?.applicationId,
    //   isCustomerOwned: true,
    //   role: 'VaultAccountRole',
    // });
    await createAccount();
  };

  const openCloudFormation = () => {
    // once clicked once, we are enabling the connection button.
    setOpenCloudFormationClicked(true);
    void validateAccount();
  };

  return (
    <PanelWrapper
      rounded
      header={{
        title: 'Connect vault account',
        subtitle:
          'Before you start, make sure you can create and manage roles in your AWS environment',
        onClose,
      }}
      footer={{
        primaryButton: {
          'data-testid': 'submit-connect-vault-account',
          text: 'Connect',
          onClick: onConnectClick,
          disabled: !openCloudFormationClicked || isCreationInProgress,
        },
      }}
    >
      <Box
        paddingY='min(60px, 4vw)'
        paddingX='min(100px, 6vw)'
        width='100%'
        height='auto'
      >
        <Stack
          width='100%'
          gap='min(60px, 4vw)'
          divider={<Divider sx={{ borderStyle: 'dashed' }} />}
        >
          <NumericBulletSection
            bulletNumber={1}
            title={`Set connection details`}
          >
            <BulletItem
              leftContent={
                <Stack gap='24px'>
                  <FormTextField
                    title='Account ID'
                    placeholder='Example: 12345678-90ab-cdef-1234-567890abcdef'
                    value={accountId}
                    onChange={(e) => setAccountId(e.target.value)}
                  />
                  <FormTextField
                    title='Eon role name'
                    placeholder='Enter role name'
                    // value={'EonVaultVerificationRole'}
                    value={roleName}
                    onChange={(e) => setRoleName(e.target.value)}
                  />
                </Stack>
              }
            />
          </NumericBulletSection>
          <NumericBulletSection bulletNumber={2} title={`Review and deploy`}>
            <Stack width='540px' gap='24px'>
              <Typography variant='body1'>
                Launch CloudFormation to review and deploy Eon’s permissions in
                your AWS account. Afterward, come back to this tab to finish the
                connection.
              </Typography>
              <ButtonWithIcon
                sx={{ width: '250px' }}
                disabled={!accountId || !roleName}
                variant='contained'
                color='primary'
                text='Launch CloudFormation in AWS'
                icon='material-symbols-open-in-new'
                iconPosition='right'
                onClick={openCloudFormation}
              />
            </Stack>
          </NumericBulletSection>
        </Stack>
      </Box>
    </PanelWrapper>
  );
};
